<template>
    <views :class="{'fixed': isShowList}" class="filter-bar">
        <views :class="{'show': isShowList}" class="filter-bar__bg" @click="toggleList"></views>
        <views class="filter-bar__container">
            <views v-if="posP" class="content">
                <views class="f-list pos" @click="toggleList">
                    <images :src="posIcon"></images>
                </views>
                <views class="f-list" @click="toggleList">
                    <views class="name">
                        {{ posP }}
                    </views>
                    <views class="name">
                        {{ posC }}
                    </views>
                    <views class="icon">
                        <images v-if="isShowList" :src="upIcon"></images>
                        <images v-else :src="downIcon"></images>
                    </views>
                </views>
            </views>
            <views v-if="list.length > 0" class="menu" @click="handleMap">
                <views :class="{'active': isMap}" class="btn">门店分布</views>
            </views>
        </views>
        <views
            :class="{'show': isShowList}"
            class="filter-bar__content">
            <views class="inner">
                <views
                    class="con-province">
                    <views
                        v-for="(item, index) in pList"
                        :key="index"
                        :class="{'active': item.active}"
                        class="list"
                        @click="handleSelectProvince(item)">
                        {{ item.area_name }}
                    </views>
                </views>
                <views
                    class="con-city">
                    <views
                        v-for="(item, index) in cityList"
                        :key="index"
                        :class="{'active': item.active}"
                        class="list"
                        @click="handleSelectCity(item)">
                        {{ item.area_name }}
                    </views>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
import api from '@/utils/api'
import getLocation from '@/mixins/getLocation'
import address from '@/mixins/address'
import posIcon from '../../assets/images/pos.png'
import downIcon from '../../assets/images/down.png'
import upIcon from '../../assets/images/up.png'
export default {
    name: 'FilterBar',
    mixins: [getLocation, address],
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            posP: '', // 当前省
            posC: '', // 当前市
            posPId: '', // 当前省id
            posCId: '', // 当前市
            provinceList: [], // 省列表
            cityList: [], // 市列表
            isShowList: false,
            activeProvince: {},
            activeCity: {},
            getCityListTimes: 0, // 获取城市列表次数
            posIcon: posIcon,
            downIcon: downIcon,
            upIcon: upIcon
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        isMap() {
            return !!this.query.map
        },
        localProvince() {
            let p = ''
            if (this.query.posP) {
                p = this.query.posP
            } else {
                p = this.getProvince || ''
            }
            return p
            // return '北京市'
        },
        localCity() {
            let c = ''
            if (this.query.posC) {
                c = this.query.posC
            } else {
                c = this.getCity || ''
            }
            return c
            // return '朝阳区'
        },
        pList() {
            return this.provinceList.map((item) => ({
                ...item,
                active: item.area_name === this.posP
            }))
        },
        cList() {
            return this.cityList.map((item) => ({
                ...item,
                active: item.area_name === this.posC
            }))
        }
    },
    watch: {
        provinceList: {
            handler(val) {
                if (val && val.length > 0) {
                    this.posP = this.localProvince
                    this.activeProvince = val.filter((item) => item.area_name === this.posP)[0]
                    // this.getCityList()
                }
            },
            immediate: false
        }
    },
    created() {
        this._cityList = []
        // this.getLocation().then((res) => {
        //     this.$emit('address', res)
        //     this.getProvinceList()
        // })
    },
    methods: {
        toggleList() {
            this.isShowList = !this.isShowList
        },
        // 获取省份列表
        getProvinceList(parentId = 0) {
            api.getAreaList({ parentId }).then((res) => {
                if (res.data) {
                    const provinceList = Object.keys(res.data.province_list).map(provId => {
                        var item = {
                            area_name: res.data.province_list[provId],
                            provinceId: provId,
                            id: provId
                        }
                        return item
                    })
                    const cityList = Object.keys(res.data.city_list).map(cityId => {
                        var item = {
                            area_name: res.data.city_list[cityId],
                            cityId: cityId,
                            id: cityId
                        }
                        return item
                    })
                    this._cityList = cityList
                    const currentProId = this.$route.query.pid || provinceList[0].provinceId
                    const currentCityId = this.$route.query.cid || cityList[0].id
                    this.posC = this.$route.query.posC || cityList[0].area_name
                    this.posP = this.$route.query.posP || provinceList[0].area_name
                    this.cityList = this._cityList.filter(pro => {
                        var proIndex2 = pro.cityId[0] + pro.cityId[1]
                        return proIndex2 === currentProId
                    })
                    this.cityList = this.cityList.map(city => {
                        if (city.id === currentCityId) {
                            city.active = true
                        }
                        return city
                    })
                    this.$emit('citychange', { posP: this.posP, posC: this.posC, provinceId: currentProId, cityId: currentCityId })
                    this.provinceList = provinceList
                }
            })
        },
        // 获取城市列表
        getCityList() {
            api.getAreaList({ parentId: this.activeProvince.parent_id }).then((res) => {
                if (res.data) {
                    this.cityList = res.data
                    this.getCityListTimes++
                    // 第一次加载城市
                    if (this.getCityListTimes === 1) {
                        this.posC = this.localCity
                        const city = this.cityList.filter((item) => item.area_name === this.posC)[0]
                        const params = {
                            provinceId: this.activeProvince.id
                        }
                        if (city) {
                            this.activeCity = city
                            params.cityId = this.activeCity.id
                        }
                        this.$emit('doQuery', {
                            ...params,
                            posP: this.posP,
                            posC: this.posC
                        })
                    }
                }
            })
        },
        // 选择省份
        handleSelectProvince(item) {
            this.activeProvince = item
            this.posP = item.area_name
            this.posPId = item.provinceId
            this.cityList = this._cityList.filter(pro => {
                var proIndex2 = pro.cityId[0] + pro.cityId[1]
                return proIndex2 === item.provinceId
            })
            this.cityList.forEach((element) => {
                element.active = false
            })
            this.activeCity = this.cityList[0]
            this.cityList[0].active = true
            this.posC = this.cityList[0].area_name
            this.posP = this.activeProvince.area_name
            this.$emit('citychange', { posP: this.posP, posC: this.posC, provinceId: this.activeProvince.id, cityId: this.cityList[0].id })
            this.$emit('doQuery', {
                provinceId: this.activeProvince.id,
                cityId: this.activeCity.id,
                posP: this.posP,
                posC: this.posC
            })
            // this.getCityList()
        },
        // 选择城市
        handleSelectCity(item) {
            this.activeCity = item
            console.log(item)
            this.posP = this.activeProvince.area_name
            this.posC = this.activeCity.area_name
            this.$emit('doQuery', {
                provinceId: this.activeProvince.id,
                cityId: this.activeCity.id,
                posP: this.posP,
                posC: this.posC
            })
            this.$emit('citychange', { posP: this.posP, posC: this.posC, provinceId: this.activeProvince.id, cityId: this.activeCity.id })
            this.toggleList()
        },
        // 门店分布
        handleMap() {
            if (this.isMap) return
            this.$emit('map', {
                posP: this.posP,
                posC: this.posC,
                provinceId: this.activeProvince.id,
                cityId: this.activeCity.id
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
